export default {
  payWelfareText: 'チャージ特典',
  blackFridayDiscount: 'ブラックフライデー期間限定割引',
  shareGift: 'シェア報酬',
  vipWeeklyWelfare: 'VIP週間特典',
  exchangeCoupon: 'クーポン交換',
  firstPayOff: '初回購入で最大15%OFF',
  blackFridayEvent: 'ブラックフライデーキャンペン',
  limitedTimeOff: '期間限定10%OFF',
  claimCoupon: '今すぐ受け取る',
  blackFridayTimedCoupon: 'ブラックフライデー期間限定クーポン',
  timeLeft: 'イベント終了まで：',
  claimTimeCoupon: '期間限定10%OFFクーポンをゲット',
  points: '残りポイント：${point}',
  costPointTip: 'ポイントを消費すると任意ランクのクーポンを受け取り可能',
  maxPointTip: '1つのアカウントにつき最大で500ポイントを使用可能',
  discountOff: '10%OFF',
  highestDiscount: '最大で${discount} 値下げ',
  needPoint: '${point}ポイントが必要',
  changeCurrency: '通貨変更',
  claim: '受け取る',
  claimSucc: '受領成功',
  claimFail: '受領失敗',
  pointNotEnough: 'ポイントが足りません。',
  afterClaimPoint: '受領後の残りポイント：${point}',
  footTips1: 'オーダーごとにクーポンを1枚のみ使用可能',
  footTips2: '金券の購入にはこのクーポンを使用できません',
  footTips3: 'イベントの最終解釈権は運営チームに属します。',
  ruleTitleText: 'イベントルール',
  ruleTime: 'イベント時間：2023-11-24 0:00 ～ 2023-11- 26 23:59 （UTC）',
  bfRuleText1:
    '1．イベント期間中、初めて公式チャージ画面にログインすると400ポイントを獲得でき、クーポンを交換することができます。（クーポンの交換は最大で500ポイントを使用できます）',
  bfRuleText2:
    '2．イベント期間中、ポイントを使用するとクーポンを交換できます。消費するポイントが多いほど、クーポンの割引も多くなります。交換後に対応するポイントが消費されます。',
  bfRuleText3:
    '2．オーダーごとに1枚のクーポンのみ使用できます。金券商品の購入にはブラックフライデー期間限定クーポンを使用できません。',
  bfRuleText4:
    '4．ブラックフライデー期間限定クーポンは以下の通貨のみ対応しています。',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5．交換後、通貨の変更やポイントの返還などはできませんので、割引情報とポイント消費にご注意ください。',
  bfRuleText6:
    '6．ブラックフライデー期間限定クーポンの有効期間は7日です。使用期限にご注意ください。',
  bfRuleText7: '7．イベントの最終解釈権は運営チームに属します。',
  thanksTip:
    'ご参加いただきありがとうございました。詳細情報は公式コミュニティをフォローしてください。',
  exchangePoints: 'ポイント交換',
  exchangeCode: '支払い方法を選んでからクーポン番号を入力してください。',
  enterExchangeCode: '交換コードを入力',
  exchangeText: '交換',
  confirmGet: '受け取る',
  couponUsedWay:
    'クーポンは指定された通貨での支払い時にのみ使用できますので、予めご注意ください。',
  confirmText: '確認',
  exchangeSucc: '交換成功',
  aboutCoins: '金券について',
  aboutCoinsText:
    '金券を使用するとゲーム内のすべてのパックおよびサービスを購入できますが、ゲーム内の金券は購入対象外です。',
  known: '了解',
  codeText: '交換コード',
  codeInvalid: '無効な交換コードです！',
  hasExchanged: '交換しました。交換コードは1回のみ使用できます。',
  hideText: 'タップで閉じる',
  //黑五的报错码
  'bf-20001': '未登録',
  'bf-20002': 'パラメータエラー。ゲーム画面を再読み込みしてください。',
  'bf-20003': 'ポイントが足りません。',
  'bf-20004':
    '受け取れません。後でもう一度試すか、お問合せに連絡してください。',
  'bf-20005': '受領済み',
  'bf-20015': 'イベント未開放です。こうご期待~',
  'bf-20016': 'イベントが終了しました。',
  bfShareText: '期間限定10%OFFクーポンをゲット',
  rightsCenterBtn: 'プレミアムセンター',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : '栄光の頂き（永久）',
  '-': '-'
};
